module.exports.industries = [
    {
        "name": "Accessories/Apparel/Fashion Design",
        "id": 2,
        "classification": "NON IT"
    },
    {
        "name": "Accounting/Consulting/Taxation",
        "id": 3,
        "classification": "NON IT"
    },
    {
        "name": "Advertising/Event Management/PR",
        "id": 4,
        "classification": "NON IT"
    },
    {
        "name": "Agriculture/Dairy Technology",
        "id": 5,
        "classification": "NON IT"
    },
    {
        "name": "Airlines/Hotel/Hospitality/Travel/Tourism/Restaurants",
        "id": 6,
        "classification": "NON IT"
    },
    {
        "name": "Animation / Gaming",
        "id": 40,
        "classification": "NON IT"
    },
    {
        "name": "Architectural Services/ Interior Designing",
        "id": 7,
        "classification": "NON IT"
    },
    {
        "name": "Auto Ancillary/Automobiles/Component",
        "id": 8,
        "classification": "NON IT"
    },
    {
        "name": "Banking / Financial Services / Broking",
        "id": 41,
        "classification": "NON IT"
    },
    {
        "name": "Banking/Financial Services/Stockbroking/Securities",
        "id": 9,
        "classification": "NON IT"
    },
    {
        "name": "Biotechnology/Pharmaceutical/Clinical Research",
        "id": 10,
        "classification": "NON IT"
    },
    {
        "name": "Brewery / Distillery",
        "id": 43,
        "classification": "NON IT"
    },
    {
        "name": "Cement/Construction/Engineering/Metals/Steel/Iron",
        "id": 11,
        "classification": "NON IT"
    },
    {
        "name": "Ceramics /Sanitary ware",
        "id": 44,
        "classification": "NON IT"
    },
    {
        "name": "Chemicals/Petro Chemicals/Plastics",
        "id": 12,
        "classification": "NON IT"
    },
    {
        "name": "Computer Hardware/Networking",
        "id": 22,
        "classification": "NON IT"
    },
    {
        "name": "Consumer FMCG/Foods/Beverages",
        "id": 13,
        "classification": "NON IT"
    },
    {
        "name": "Consumer Goods - Durables",
        "id": 14,
        "classification": "NON IT"
    },
    {
        "name": "Courier/Freight/Transportation/Warehousing",
        "id": 15,
        "classification": "NON IT"
    },
    {
        "name": "CRM/ IT Enabled Services/BPO",
        "id": 16,
        "classification": "IT"
    },
    {
        "name": "Education/Training/Teaching",
        "id": 17,
        "classification": "NON IT"
    },
    {
        "name": "Electricals / Switchgears",
        "id": 46,
        "classification": "NON IT"
    },
    {
        "name": "Employment Firms/Recruitment Services Firms",
        "id": 18,
        "classification": "CONSULTANT"
    },
    {
        "name": "Entertainment/Media/Publishing/Dotcome",
        "id": 19,
        "classification": "NON IT"
    },
    {
        "name": "Export Houses/Textiles/Merchandise",
        "id": 20,
        "classification": "NON IT"
    },
    {
        "name": "Facility Management",
        "id": 48,
        "classification": "NON IT"
    },
    {
        "name": "Fertilizers / Pesticides",
        "id": 49,
        "classification": "NON IT"
    },
    {
        "name": "Food Processing",
        "id": 50,
        "classification": "NON IT"
    },
    {
        "name": "Gems and Jewellery",
        "id": 21,
        "classification": "NON IT"
    },
    {
        "name": "Glass",
        "id": 51,
        "classification": "NON IT"
    },
    {
        "name": "Government / Defence",
        "id": 45,
        "classification": "NON IT"
    },
    {
        "name": "Healthcare/Medicine",
        "id": 23,
        "classification": "NON IT"
    },
    {
        "name": "Heat Ventilation/ Air Conditioning",
        "id": 52,
        "classification": "NON IT"
    },
    {
        "name": "Insurance",
        "id": 24,
        "classification": "NON IT"
    },
    {
        "name": "Internet/Ecommerce",
        "id": 61,
        "classification": "IT"
    },
    {
        "name": "KPO / Research /Analytics",
        "id": 53,
        "classification": "NON IT"
    },
    {
        "name": "Law/Legal Firms",
        "id": 25,
        "classification": "NON IT"
    },
    {
        "name": "Machinery/Equipment Manufacturing/Industrial Products",
        "id": 26,
        "classification": "NON IT"
    },
    {
        "name": "Medical Devices/Equipments",
        "id": 62,
        "classification": "NON IT"
    },
    {
        "name": "Mining",
        "id": 54,
        "classification": "NON IT"
    },
    {
        "name": "NGO/Social Services",
        "id": 27,
        "classification": "NON IT"
    },
    {
        "name": "Office Automation",
        "id": 28,
        "classification": "IT"
    },
    {
        "name": "Other",
        "id": 1000,
        "classification": "NON IT"
    },
    {
        "name": "Others/Engg. Services/Service Providers",
        "id": 37,
        "classification": "NON IT"
    },
    {
        "name": "Petroleum/Oil and Gas/Projects/Infrastructure/Power/Non-conventional Energy",
        "id": 29,
        "classification": "NON IT"
    },
    {
        "name": "Power / Energy",
        "id": 39,
        "classification": "NON IT"
    },
    {
        "name": "Printing/Packaging",
        "id": 30,
        "classification": "NON IT"
    },
    {
        "name": "Publishing",
        "id": 55,
        "classification": "NON IT"
    },
    {
        "name": "Real Estate",
        "id": 31,
        "classification": "NON IT"
    },
    {
        "name": "Retailing",
        "id": 32,
        "classification": "NON IT"
    },
    {
        "name": "Security/Law Enforcement",
        "id": 33,
        "classification": "NON IT"
    },
    {
        "name": "Shipping/Marine",
        "id": 38,
        "classification": "NON IT"
    },
    {
        "name": "Software Services",
        "id": 34,
        "classification": "IT"
    },
    {
        "name": "Steel",
        "id": 56,
        "classification": "NON IT"
    },
    {
        "name": "Strategy /Management Consulting Firms",
        "id": 57,
        "classification": "NON IT"
    },
    {
        "name": "Telecom Equipment/Electronics/Electronic Devices/RF/Mobile Network/Semi-conductor",
        "id": 35,
        "classification": "NON IT"
    },
    {
        "name": "Telecom/ISP",
        "id": 36,
        "classification": "NON IT"
    },
    {
        "name": "Tyres",
        "id": 58,
        "classification": "NON IT"
    },
    {
        "name": "Water Treatment / Waste Management",
        "id": 59,
        "classification": "NON IT"
    },
    {
        "name": "Wellness/Fitness/Sports",
        "id": 60,
        "classification": "NON IT"
    }
];